module.exports = __webpack_public_path__ + "static/media/26.a3ee2d7f.jpeg";